import React from 'react';
import { LinkHandler, Typography } from '@/components/atoms';
import styled from 'styled-components';
import { ILinkBackCmp } from './ILinkBackCmp';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const IconWrapper = styled.div`
  margin-right: 4px;
`;

const LinkHandlerWrapper = styled.div`
  /* font-size: 14px;
  font-weight: bold; */
  & a {
    color: ${props => props.theme.paletteDefault.primary.main};
  }
`;

const LinkBack: React.FC<ILinkBackCmp> = ({ href, clickHandler, label }) => {
  const element = (
    <Wrapper>
      {label && (
        <IconWrapper>
          <ArrowBackIcon style={{ fontSize: 12 }} />
          {/* <Image
            src="/asset/arrowleft.svg"
            alt={'arrow left icon'}
            width={12}
            height={12}
            unoptimized={true}
          /> */}
        </IconWrapper>
      )}
      <Typography datatype="caption_1">{label}</Typography>
    </Wrapper>
  );

  return (
    <LinkHandlerWrapper>
      {href ? (
        <LinkHandler href={href} shallow={true}>
          {element}
        </LinkHandler>
      ) : (
        <div onClick={clickHandler}>{element}</div>
      )}
    </LinkHandlerWrapper>
  );
};

export default LinkBack;
